import { styled } from "@material-ui/core/styles";
import { Container } from "@material-ui/core";

import theme from "../constants/theme";

export default styled(Container)({
  [theme.breakpoints.only("xs")]: {
    width: "85vw",
  },
});
